export enum TokenType {
  SessionGuid = 1,
  PubCenterAADToken = 4,
}
